import { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Check, Undo2, Store } from "lucide-react";
import { Button } from "./ui/button";
import { Input } from "./ui/input";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// In-passport REDEEM: the business taps it on the donor's phone, types "redeem", done. 60s undo.
export const GemRedeemButton = ({ tile, business, onChange }) => {
  const [open, setOpen] = useState(false);
  const [typed, setTyped] = useState("");
  const [staff, setStaff] = useState("");
  const [busy, setBusy] = useState(false);
  const [stampedAt, setStampedAt] = useState(null);
  const call = async (extra = {}) => {
    setBusy(true);
    try {
      const r = await axios.post(`${API}/passport/me/redeem`, { tile_id: tile.tile_id, business_id: business.business_id, confirm: typed, staff_name: staff, ...extra }, { withCredentials: true });
      if (r.data.undone) { setStampedAt(null); toast("Redemption undone."); }
      else { setStampedAt(r.data.stamp?.stamped_at || new Date().toISOString()); toast.success(`Redeemed at ${business.business_name}. Enjoy!`); }
      setOpen(false); setTyped("");
      onChange?.();
    } catch (e) { toast.error(e.response?.data?.detail || "Couldn't redeem"); }
    finally { setBusy(false); }
  };
  const [, tick] = useState(0);
  useEffect(() => { if (!stampedAt) return; const t = setTimeout(() => tick((n) => n + 1), 5200); return () => clearTimeout(t); }, [stampedAt]);
  const canUndo = stampedAt && Date.now() - new Date(stampedAt).getTime() < 5000;
  if (tile.redeemed && !canUndo) return null;
  if (canUndo) {
    return (
      <button type="button" onClick={() => call({ undo: true, confirm: "redeem" })} className="mt-2 inline-flex items-center gap-1 text-xs text-white/70 underline" data-testid={`gem-undo-${tile.tile_id}`}>
        <Undo2 className="h-3 w-3" /> Tapped by mistake? Undo (5s)
      </button>
    );
  }
  return (
    <div className="mt-2">
      {!open ? (
        <Button type="button" size="sm" onClick={() => setOpen(true)} className="rounded-full bg-white text-[#1D4ED8] hover:bg-blue-50 border border-[#1D4ED8]/30 font-extrabold text-sm px-5 py-5" data-testid={`gem-redeem-${tile.tile_id}`}>
          <Store className="h-4 w-4 mr-1.5" /> REDEEM — business taps here
        </Button>
      ) : (
        <div className="rounded-lg bg-black/40 border border-amber-400/50 p-3 space-y-2" data-testid={`gem-redeem-panel-${tile.tile_id}`}>
          <p className="text-sm text-white/85"><strong className="text-amber-300">Hand your phone to the business.</strong> Staff: type <strong>REDEEM</strong> to stamp this Gem. <strong>This can't be undone</strong> — one use per HOARD.</p>
          <Input value={typed} onChange={(e) => setTyped(e.target.value)} placeholder="type REDEEM" autoFocus className="bg-white text-[#1A1A1A] h-9 font-bold tracking-widest uppercase" data-testid={`gem-redeem-input-${tile.tile_id}`} />
          <Input value={staff} onChange={(e) => setStaff(e.target.value)} placeholder="Your first name (optional)" className="bg-white/90 text-[#1A1A1A] h-8 text-xs" data-testid={`gem-redeem-staff-${tile.tile_id}`} />
          <div className="flex gap-2">
            <Button type="button" size="sm" disabled={busy || typed.trim().length < 4} onClick={() => call()} className="rounded-full bg-white text-[#1D4ED8] hover:bg-blue-50 border border-[#1D4ED8]/30 font-extrabold text-sm" data-testid={`gem-redeem-confirm-${tile.tile_id}`}>
              <Check className="h-3.5 w-3.5 mr-1" /> Stamp it
            </Button>
            <Button type="button" size="sm" variant="ghost" onClick={() => { setOpen(false); setTyped(""); }} className="text-white/70 text-xs">Cancel</Button>
          </div>
        </div>
      )}
    </div>
  );
};
